<template>
  <section class="clear">
    <div class="panel-heading" style="background-color: #FFFFFF; border-color: #eaeef1;">
      <span v-if="isOwner" class="dropdown pull-right">
        <a class="dropdown-toggle" data-toggle="dropdown">
          <i class="i i-arrow-down4" style="margin-left:10px;"></i>
        </a>
        <ul class="dropdown-menu">
          <li>
            <a class="feed-delete" @click="deleteActivity(activity)">
              <i class="fa fa-trash-o"></i> Delete
            </a>
          </li>
        </ul>
      </span>
      <div class="m-l-sm pull-right">
        <span
          class="m-l-sm pull-left time-ago--font"
          style="display: flex;align-items: center;"
        >{{getAgo(activity.time_stamp)}}</span>
      </div>
      <a class="thumb-xs pull-left m-r" :href="getOwnerUrl()">
        <img class="img-circle thumb-xs" :src="this.activity.owner.avatar" />
      </a>
      <div
        class="clear activity-owner font-bold"
        v-html="$t('feed.' + activity.content_type + '_' + activity.action_name.toLowerCase(), {nickname: resizeOwner(activity.owner.name, 10, true), url: getOwnerUrl()})"
      ></div>
    </div>

    <!-- <div class="force-overflow"> -->
    <div class="panel-body mobile-margin-left">
      <item-body :activity="activity"></item-body>
    </div>
    <!-- </div> -->
    <div class="row social-like-item m-n">
      <div class="col-sm-8" style="padding-left: 6px;">
        <div class="social-like-form text-right m-r-sm">
          <div class="pull-left" style="position: relative; margin-left: 10px; height: 40px;">
            <div class="row">
              <div class="like_container">
                <div
                  class="like_icons bg-white wrapper-sm b-a box-shadow rounded-5"
                  style="margin-top: -35px; margin-left: 10px;"
                >
                  <div class="block inline text-center m-r-xs m-t-xs active">
                    <a class="event-like share-icon" @click="like(activity, 1)">
                      <img
                        src="https://s3-ap-southeast-1.amazonaws.com/ukuyacommunity/system/social/awesome48x48.png"
                        title="Awesome"
                        alt="Awesome"
                        width="32px"
                      />
                    </a>
                    <div class="block text-center text-xs active">Awesome</div>
                  </div>
                  <div class="block inline text-center m-r-xs m-t-xs active">
                    <a class="event-like share-icon" @click="like(activity, 2)">
                      <img
                        src="https://s3-ap-southeast-1.amazonaws.com/ukuyacommunity/system/social/confused48x48.png"
                        title="Confused"
                        alt="Confused"
                        width="32px"
                      />
                    </a>
                    <div class="block text-center text-xs active">Confused</div>
                  </div>
                  <div class="block inline text-center m-r-xs m-t-xs active">
                    <a class="event-like share-icon" @click="like(activity, 3)">
                      <img
                        src="https://s3-ap-southeast-1.amazonaws.com/ukuyacommunity/system/social/shock48x48.png"
                        title="Shocked"
                        alt="Shocked"
                        width="32px"
                      />
                    </a>
                    <div class="block text-center text-xs active">Shocked</div>
                  </div>
                </div>
                <a class="social-like-show-actions hidden share-expanded">&nbsp;</a>
              </div>
            </div>
          </div>
        </div>
        <div class="social-like-info clearfix m-t-sm pull-left">
          <a v-if="!reactionsCount && !rIsOwner" class="social-likes pull-right">
            <span>
              <i class="text-muted fa fa-thumbs-up fa-lg"></i> rate this
            </span>
          </a>
          <a v-if="reactionsCount && !rIsOwner" class="social-likes pull-right">
            <span>
              <i class="text-muted fa fa-thumbs-up fa-lg"></i>
              {{reactionsCount}} people rated this
            </span>
          </a>
          <a v-if="reactionsCount && rIsOwner" class="social-likes pull-right not-reactions">
            <span v-if="this.rAwesome" style="margin-left:10px;">
              <img
                src="https://s3-ap-southeast-1.amazonaws.com/ukuyacommunity/system/social/awesome16x16.png"
              />
              {{resizeOwner(profileName, 25)}}
              <span v-if="reactionsCount-1">and {{reactionsCount-1}} others</span>
            </span>
            <span v-else-if="this.rConfused" style="margin-left:10px;">
              <img
                src="https://s3-ap-southeast-1.amazonaws.com/ukuyacommunity/system/social/confused16x16.png"
              />
              {{resizeOwner(profileName, 25)}}
              <span v-if="reactionsCount-1">and {{reactionsCount-1}} others</span>
            </span>
            <span v-else-if="this.rShocked" style="margin-left:10px;">
              <img
                src="https://s3-ap-southeast-1.amazonaws.com/ukuyacommunity/system/social/shock16x16.png"
              />
              {{resizeOwner(profileName, 25)}}
              <span v-if="reactionsCount-1">and {{reactionsCount-1}} others</span>
            </span>
          </a>
        </div>
      </div>
      <div class="col-sm-4">
        <a class="social-like-info-02 pull-right m-t-sm text-right">
          <div class="text-right">
            <span v-if="this.rAwesome" class="block inline">
              <span class="text-lg">{{this.rAwesome}}</span>
              <img
                class="inline m-t-n-xs get-likes"
                src="https://s3-ap-southeast-1.amazonaws.com/ukuyacommunity/system/social/awesome16x16.png"
              />
            </span>
            &nbsp;
            <span v-if="this.rConfused" class="block inline">
              <span class="text-lg">{{this.rConfused}}</span>
              <img
                class="inline m-t-n-xs get-likes"
                src="https://s3-ap-southeast-1.amazonaws.com/ukuyacommunity/system/social/confused16x16.png"
              />
            </span>
            &nbsp;
            <span v-if="this.rShocked" class="block inline">
              <span class="text-lg">{{this.rShocked}}</span>
              <img
                class="inline m-t-n-xs get-likes"
                src="https://s3-ap-southeast-1.amazonaws.com/ukuyacommunity/system/social/shock16x16.png"
              />
            </span>
            &nbsp;
          </div>
        </a>
      </div>
    </div>
    <div class="panel-footer">
      <div class="comments-container">
        <div class="comment-list pagination-list" id="yw0">
          <div class="items">
            <div v-for="(comment, index) of comments" :key="index">
              <div id="comment-id-548" class="comment-item m-b-sm">
                <span class="pull-left thumb-sm avatar m-r">
                  <a class="pull-left thumb-sm avatar" style="width: 34px; height: 34px;">
                    <img :src="fetchCommentItemAvatar(comment)" class="img-circle" />
                  </a>
                </span>
                <span class="clear">
                  <span class="font-bold comment-profile-name">
                    <a v-if="comment.profile.name">{{comment.profile.name}}</a>
                    <a v-else>{{'Anonymous'}}</a>
                  </span>
                  <small
                    class="text-black clear comment-text"
                    style="word-wrap: break-word"
                  >{{comment.text}}</small>
                  <small class="comment-time-ago">
                    {{getAgo(comment.time)}}
                    <span
                      v-if="isOwn(comment.profile.id)"
                      class="comment-action m-l-sm"
                    >
                      <a v-on:click="deleteComment(comment)" class="delete-comment">
                        <i class="fa fa-trash-o text-muted"></i> delete
                      </a>
                    </span>
                  </small>
                </span>
              </div>
            </div>

            <center>
              <pagination
                v-model="page"
                :options="paginationOptions"
                :per-page="limit"
                :records="count ? count : 0"
                @paginate="getComments"
              ></pagination>
            </center>
          </div>
          <div
            class="keys"
            style="display:none"
            title="/ukuya/default/comments/list?content_type=feed&amp;content_id=3283"
          ></div>
        </div>
        <article class="clear comment-item block chat-item left">
          <a href="#" class="pull-left thumb-sm avatar">
            <img class="thumb-sm" :src="getProfileAvatar()" />
          </a>
          <section class="chat-body">
            <form class="comment-create-form m-b-none">
              <input type="hidden" name="Comments[content_type]" value="feed" />
              <input type="hidden" name="Comments[content_id]" value="3283" />
              <input type="hidden" name="Comments[parent_id]" value="0" />
              <div class="input-group margin-none">
                <textarea
                  class="form-control comment-field"
                  @keyup="checkSend"
                  style="height: 34px;resize: none;"
                  v-model="text"
                  placeholder="add comment"
                ></textarea>
                <span class="input-group-btn v-bottom">
                  <button class="btn btn-default" v-on:click="setComment()" type="button">Post</button>
                </span>
              </div>
            </form>
          </section>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
import moment from "moment-timezone";
import itemBody from "./item-body";
import { loadImage } from "@src/helpers/image-helper";
import Pagination from "vue-pagination-2";
import ApiService from "../../../../services/ApiService";

export default {
  name: "item",
  components: {
    itemBody,
    Pagination
  },
  data() {
    return {
      comments: [],
      reactions: [],
      profileName: window.user.name,
      reactionsCount: 0,
      rAwesome: 0,
      rConfused: 0,
      rShocked: 0,
      page: 1,
      limit: 5,
      count: null,
      image: null,
      text: null,
      isOwner: false,
      rIsOwner: false,
      apiService: new ApiService(),
      paginationOptions: {
        texts: {
          count: "||"
        }
      }
    };
  },
  created() {
    moment.updateLocale("en", {
      relativeTime: {
        future: "in %s",
        past: "%s ago",
        s: "%ds",
        m: "1m",
        mm: "%dm",
        h: "1h",
        hh: "%dh",
        d: "1d",
        dd: "%dd",
        M: "1 month",
        MM: "%d months",
        y: "1 year",
        yy: "%d years"
      }
    });
    this.getComments();
    this.getReactions();
    this.defineOwner();
  },
  mounted() {
    $(document).find(".social-likes").unbind("click");
    $(document).find(".social-likes").click(e => {
      if ($(e.currentTarget).hasClass("not-reactions")) return;
      $(e.currentTarget)
        .closest(".social-like-item")
        .find(".like_icons")
        .toggleClass("active");
    });
    loadImage(
      (this.activity.owner.thumbs['thumb-xs'] !== 'undefined') ? this.activity.owner.thumbs['thumb-xs'] : null,
      'https://ukuyacommunity.s3.amazonaws.com/system/profile_default.jpg',
      null,
      src => this.activity.owner.avatar = src
    );
  },
  computed: {
    profile() {
      return this.$store.getters.profile;
    }
  },
  props: {
    activity: null
  },
  watch: {
    activity: function(to) {
      this.activity = to;
    }
  },
  methods: {
    like(activity, type) {
      $(document)
        .find(".like_icons")
        .removeClass("active");
      this.apiService
        .post(
          `/social/reactions`,
          this.preparingBodyLike(type, "feed", activity.id)
        )
        .then(res => {
          this.getReactions();
        });
    },
    preparingBodyLike(type, content_type, content_id) {
      var formData = new FormData();
      formData.append("action_id", type);
      //formData.append('profile_id', window.user.profile_id);
      formData.append("content_type", content_type);
      formData.append("content_id", content_id);
      return formData;
    },
    defineOwner() {
      this.isOwner = this.profile.profile_id === window.user.profile_id;
    },
    resizeOwner(name, size = 10, auto = false) {
      let width = $(".activity-owner").width();
      if (auto) {
        size = Math.floor(width / 11);
        if (size < 20) size = 10;
      }
      let res = "";
      if (name.length > size) {
        res = name.substr(0, size) + "...";
      } else res = name;
      return res;
    },
    isOwn(profile_id) {
      return profile_id === window.user.profile_id;
    },
    getAgo(time) {
      return moment.unix(time).fromNow();
    },
    deleteComment(comment) {
      this.apiService.delete(`/social/comments/${comment.id}`).then(res => {
        this.comments.map((c, i) => {
          if (comment.id === c.id) {
            this.comments.splice(i, 1);
          }
        });
      });
    },
    deleteActivity(activity) {
      this.apiService.delete(`/activity/delete?id=${activity.id}`).then(res => {
        this.$emit("delete-activity", activity);
      });
    },
    getComments(page = 1) {
      this.apiService
        .get(
          `/social/comments?content_type=feed&community_id=${window.user.community_id}&content_id=${this.activity.id}&page=${page}&per-page=${this.limit}&expand=profile`
        )
        .then(res => {
          this.page = res._meta.currentPage;
          this.count = res._meta.totalCount;
          this.comments = res.items;
        });
    },
    getReactions() {
      this.apiService
        .get(
          `/social/reactions?content_type=feed&content_id=${this.activity.id}&community_id=${window.user.community_id}&page=1&per-page=99999`
        )
        .then(res => {
          this.reactions = res.items;
          this.rAwesome = 0;
          this.rConfused = 0;
          this.rShocked = 0;
          this.reactionsCount = this.reactions.length;
          this.reactions.map((r, i) => {
            if (!this.rIsOwner)
              this.rIsOwner = r.profile_id === window.user.profile_id;
            this.setLike(r.action_id);
          });
        });
    },
    setLike(type = null) {
      switch (type) {
        case 1:
          this.rAwesome++;
          break;
        case 2:
          this.rConfused++;
          break;
        case 3:
          this.rShocked++;
          break;
      }
    },
    setComment() {
      if (!this.text) return null;
      this.apiService
        .post(`/social/comment-add`, this.prepareBody(this.text))
        .then(res => {
          this.text = "";
          this.comments.push(res);
        });
    },
    checkSend(e) {
      if (e.which === 13 && !e.shiftKey) {
        this.setComment();
      }
    },
    prepareBody(text = null) {
      if (!text) return null;
      return {
        content_type: "feed",
        community_id: window.user.community_id,
        content_id: this.activity.id,
        //profile_id: window.user.profile_id,
        text: text
      };
    },
    getOwnerUrl() {
      switch (this.activity.owner.type) {
        case 1:
          return `${window.user.community_url}/${window.user.community_domain}/default/profiles/${this.activity.owner.id}`;
        case 2:
          return `${window.user.community_url}/${window.user.community_domain}/default/corporate#/view/${this.activity.owner.id}`;
        default:
          return null;
      }
    },
    fetchCommentItemAvatar(comment) {
      loadImage(
        (comment.profile.thumbs['thumb-sm'] !== 'undefined') ? comment.profile.thumbs['thumb-sm'] : null,
				'https://ukuyacommunity.s3.amazonaws.com/system/profile_default.jpg',
				null,
				src => comment.profile.avatar = src
      );
      return comment.profile.avatar;
    },
    getProfileAvatar(){
      return window.user.avatar;
    }
  }
};
</script>

<style lang="scss" scoped>
.p-n {
  padding: 0;
}
.thumb-xs {
  .heigthFull {
    height: 24px;
  }
}
strong {
  display: inline;
}
a {
  display: inline;
}
.comment-profile-name {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}
.event-like img {
  transition: transform 0.2s;
}
.event-like img:hover {
  transform: scale(1.2);
}
.social-likes {
  font-size: 14px;
  line-height: 21px;
  color: #3c4144;
}
.thumb {
  width: 44.87px;
}
.thumb-xs {
  width: 24px;
  height: 24px;
}
@media only screen and (min-width: 1200px) {
  .activity-owner {
    &::v-deep strong {
      font-weight: 700;
      font-size: 14px;
      line-height: 21px;
      color: #3c4144;
    }
    &::v-deep span {
      font-weight: normal;
      font-size: 14px;
      line-height: 21px;
      color: #333;
    }
  }
  .time-ago--font {
    font-weight: 400;
    font-size: 11px;
    line-height: 1.3;
    color: #777;
  }
  .comment-profile-name {
    font-weight: 700;
    font-size: 14px;
    line-height: 21px;
    color: #3c4144;
  }
  .comment-text {
    font-size: 12px;
    line-height: 21px;
    color: rgba(0, 0, 0, 0.8);
  }
  .comment-time-ago {
    font-size: 12px;
    line-height: 21px;
    color: #777;
  }
  .thumb-sm {
    width: 36px;
    height: 36px;
  }
}
@media only screen and (max-width: 1199px) and (min-width: 1024px) {
  .activity-owner {
    &::v-deep strong {
      font-weight: 700;
      font-size: 14px;
      line-height: 21px;
      color: #3c4144;
    }
    &::v-deep span {
      font-weight: normal;
      font-size: 14px;
      line-height: 21px;
      color: #333;
    }
  }
  .time-ago--font {
    font-weight: 400;
    font-size: 11px;
    line-height: 1.3;
    color: #777;
  }
  .comment-profile-name {
    font-weight: 700;
    font-size: 14px;
    line-height: 21px;
    color: #3c4144;
  }
  .comment-text {
    font-size: 12px;
    line-height: 21px;
    color: rgba(0, 0, 0, 0.8);
  }
  .comment-time-ago {
    font-size: 12px;
    line-height: 21px;
    color: #777;
  }
}
@media only screen and (max-width: 1023px) and (min-width: 768px) {
  .activity-owner {
    &::v-deep strong {
      font-weight: 700;
      font-size: 14px;
      line-height: 21px;
      color: #3c4144;
    }
    &::v-deep span {
      font-weight: normal;
      font-size: 14px;
      line-height: 21px;
      color: #333;
    }
  }
  .time-ago--font {
    font-weight: 400;
    font-size: 11px;
    line-height: 1.3;
    color: #777;
  }
  .comment-profile-name {
    font-weight: 700;
    font-size: 14px;
    line-height: 21px;
    color: #3c4144;
  }
  .comment-text {
    font-size: 12px;
    line-height: 21px;
    color: rgba(0, 0, 0, 0.8);
  }
  .comment-time-ago {
    font-size: 12px;
    line-height: 21px;
    color: #777;
  }
}

@media only screen and (max-width: 767px) {
  .activity-owner {
    &::v-deep strong {
      font-weight: 700;
      font-size: 14px;
      line-height: 21px;
      color: #3c4144;
    }
    &::v-deep span {
      font-weight: normal;
      font-size: 14px;
      line-height: 21px;
      color: #333;
    }
  }
  .time-ago--font {
    font-weight: 400;
    font-size: 11px;
    line-height: 1.3;
    color: #777;
  }
  .thumb {
    width: 30px;
    margin-right: 11px !important;
  }
  .avatar {
    width: 36px;
  }
  .chat-body {
    margin-left: 45px;
  }
  .margin-none {
    margin: none !important;
  }
  .comment-profile-name {
    font-weight: normal;
    font-size: 11px;
    line-height: 13px;
    color: #3c4144;
  }
  .comment-text {
    font-size: 12px;
    line-height: 21px;
    color: rgba(0, 0, 0, 0.8);
  }
  .comment-time-ago {
    font-size: 12px;
    line-height: 21px;
    color: #777;
  }
  .mobile-margin-left {
    // margin-left: 45px !important;
  }
}
</style>
